var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "k-title-container",
      attrs: { "data-cy": _vm.column.downloadable ? "" : "non-downloadable" }
    },
    [
      _c(
        "v-tooltip",
        {
          attrs: { top: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attr = ref.attr
                return [
                  _c(
                    "div",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "k-title-text",
                          class: {
                            "k-title-sortable": _vm.showSortBtn && !_vm.disabled
                          },
                          on: {
                            click: function($event) {
                              _vm.showSortBtn && !_vm.disabled
                                ? _vm.handleSortClick($event)
                                : undefined
                            }
                          }
                        },
                        "div",
                        attr,
                        false
                      ),
                      _vm.hasTooltip ? on : undefined
                    ),
                    [
                      _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.title) +
                            _vm._s(_vm.sortIndicator) +
                            "\n          "
                        ),
                        _vm.sortCount
                          ? _c("span", { staticClass: "k-sort-order" }, [
                              _vm._v(_vm._s(_vm.sortCount))
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.column.tooltip || _vm.title))])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }